import DiscoverIconSM from "@/components/DiscoverIconSm";
import { Center, Container, Heading, Text } from "@chakra-ui/react";
import Head from "next/head";

export default function GetApp() {
  return (
    <>
      <Head>
        <title>Songcards for iOS and Android</title>
        <link rel="icon" href="/SC Icon_A_Light.svg" />
        <meta
          name="description"
          content="Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href={`https://songcards.io/get-app`} />
        {/* <link rel="apple-touch-icon" href="/SC Icon_A_Light.svg" /> */}
        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/get-app" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Songcards: Listen | Discover | Collect"
        />
        <meta
          property="og:description"
          content="Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Songcards: Listen | Discover | Collect"
        />
        <meta
          name="twitter:description"
          content="Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go."
        />
        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <meta name="apple-itunes-app" content="app-id=6737206374" />
      </Head>
      <Container mb={200}>
        <Heading mb={6} textAlign="center">
          Songcards for iOS and Android
        </Heading>
        <Center>
          <Text textAlign="center" mb={1} maxW={"sm"} fontSize="md">
            Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go.
          </Text>
        </Center>
        <Center mt={0} mb={10}>
          <a
            href="https://apps.apple.com/us/app/songcards/id6737206374?itscg=30200&itsct=apps_box_badge&mttnsubad=6737206374"
            style={{ display: "inlineBlock" }}
            target="_blank"
          >
            <img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1733443200"
              alt="Download on the App Store"
              style={{
                width: 123,
                height: 41,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.songcards.songcards&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              style={{
                width: 155,
                height: 100,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
        </Center>
        <Heading>Listen</Heading>
        <br />
        <Text>
          Listen The Songcards app features a built in music player so you can
          enjoy your collection on the go.
        </Text>
        <br />
        <Heading>Discover</Heading>
        <br />
        <Text>
          When you discover a Songcard link in the wild, you can open it here in
          the app, purchase it and add it to your collection. You will also find
          an ever-growing range of undiscovered artist in our Featured section.
        </Text>
        <br />
        <Heading>Collect</Heading>

        <br />
        <Text>
          Purchase music easily in the Songcards app and get instant access to
          your collection. Seamlessly add songs to the playback queue for
          non-stop listening.
        </Text>
        <br />
        <Heading>Share</Heading>
        <br />
        <Text>
          As you build your collection, you build your identity as a music
          collector and curator. You can then show off your collection via your
          personal QR code or your collector link. In turn this provides a way
          to support your artists by promoting their work.
        </Text>
        <br />
        <Heading>for Artists</Heading>
        <br />
        <Text>
          If you are a music maker and would like to create and list your own
          songcards, head over to https://create.songcards.io
        </Text>
        <br />
        <Heading>What is a songcard?</Heading>
        <br />
        <Text>
          A songcard is a digital music collectable that{`’`}s composed of a
          song and a piece of artwork.
          <br />
          <br />
          When you own a songcard, you have a connection between you and the
          artist that you don{`’`}t get on streaming platforms.
          <br />
          <br />
          Not only that, but collecting songcards demonstrates that you are a
          true fan of that artist. And when that artist blows up, you have proof
          you believed in them before everyone else did.
          <br />
          <br />
          We call this Proof Of Fan.
        </Text>
        <br />
        <Heading>Proof Of Fan</Heading>
        <br />
        <Text>
          As you build your songcard collection, you become a curator of music
          and get to show off your taste. You can do this by posting and sharing
          your collector{`'`}s page on social media. Not only does this prove
          that you discover emerging talent first, but it{`’`}s also a great way
          to promote the artists you love.
          <br />
          <br />
          The Songcards app is your musical passport as a collector. In the
          future, this app will be your ticket to experiences offered by the
          artists you collect from.
          <br />
          {/* <br />
          Support: https://songcards.io/account */}
        </Text>
        <br />
        <br />
        <Center mt={5} mb={5}>
          <a
            href="https://apps.apple.com/us/app/songcards/id6737206374?itscg=30200&itsct=apps_box_badge&mttnsubad=6737206374"
            style={{ display: "inlineBlock" }}
            target="_blank"
          >
            <img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1733443200"
              alt="Download on the App Store"
              style={{
                width: 123,
                height: 41,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.songcards.songcards&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              style={{
                width: 155,
                height: 100,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
        </Center>
        <br />
        <DiscoverIconSM />
      </Container>
    </>
  );
}
